import React, { PureComponent } from 'react';
import { strCount } from '../../../helpers/stringutils';
import _filter from 'lodash/filter';
import ResponsiveImage from '../../shared/responsiveImage';
import { getCyoaName } from '../../../helpers/cyoaHelper';


class BuilderCard extends PureComponent {

  constructor(props){
    super(props);
    this.closeClicked = this.closeClicked.bind(this);
    this.plusClicked = this.plusClicked.bind(this);
  }


  closeClicked(){
    this.props.onCloseClicked(this.props.index);
  }

  plusClicked(){
    this.props.onPlusClicked();
  }

  render(){

    const { id, type, showClose, showPlus,  sequence, image, data } = this.props;

    let _image;


    if(id === 'builder-view'){
      _image = (type === 'sector') ? sequence.images : sequence.media;
    }

    if(id === 'next-destination-view'){
      
      try{
        _image = (type === 'sector') ? image.images :  image.media;
      }catch(e){ 
        _image = [];
      }

    }

    //console.log(sequence, data);
    const _name = showClose ? sequence.name : data.name;
    const _price = showClose ? sequence.price : data.price;
    const _description = showClose ? sequence.description : data.description;
    const productClass = type === 'product' ? 'fixed-product' : '';

    const _cardImage = _filter(_image, {'title': 'hero'})[0] !== undefined ? _filter(_image, {'title': 'hero'})[0].url : "";


    return (
      <div className={`builder--card ${id} ${productClass} ${getCyoaName()}`} onClick={ showPlus ? this.plusClicked : null }>
          <div className="row">
            <div className="column small-4 medium-4 large-3">
              <div className="builder-card-image">
                <ResponsiveImage width={114} widthRetina={228} src={_cardImage} alt={_name} quality={60} />
              </div>
            </div>
            <div className="column small-5 medium-5 large-6">
              <div className="builder-card-text simple-builder">
                <h6 className={`busabout-h6 ${strCount(_name, 21, 'small')}`}>{_name}</h6>
                {
                  (type === 'product')
                  ?
                    <p className="viking-text uppercase text-left">{_description} <br />
                    <span className="price">price from <strong>{_price}</strong></span></p>
                  : ''
                }
              </div>
            </div>

            <div className="column small-3 medium-3 large-3 button-svg" style={{display: showClose ? "block" : "none"}}>
              <svg width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg" onClick={this.closeClicked} className="close-svg">
                <path d="M10.978 9.56l7.673-7.713a.678.678 0 0 0 0-.956l-.475-.478a.67.67 0 0 0-.951 0L9.552 8.127 1.88.418a.67.67 0 0 0-.95 0L.453.896a.678.678 0 0 0 0 .956L8.126 9.56.46 17.274a.678.678 0 0 0 0 .956l.475.478a.67.67 0 0 0 .95 0l7.667-7.714 7.673 7.714a.67.67 0 0 0 .95 0l.476-.478a.678.678 0 0 0 0-.956L10.978 9.56z" fill="#F14859" fillRule="nonzero" opacity=".501"/>
              </svg>
            </div>

            <div className="column small-3 medium-3 large-3 button-svg" style={{display: showPlus ? "block" : "none"}}>
              <svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" className="plus-svg">
                <g transform="translate(.22 .323)" fill="none" fillRule="evenodd">
                  <ellipse fill="#FFF" cx="12.445" cy="12.419" rx="12.445" ry="12.419"/>
                  <path d="M18.868 12.119v.6c0 .331-.27.602-.602.602h-4.918v4.907c0 .33-.27.601-.602.601h-.602a.603.603 0 0 1-.602-.6V13.32H6.624a.603.603 0 0 1-.602-.601v-.601c0-.33.27-.601.602-.601h4.918V6.61c0-.33.27-.6.602-.6h.602c.331 0 .602.27.602.6v4.908h4.918c.331 0 .602.27.602.6zm6.022.3c0 6.861-5.57 12.42-12.445 12.42S0 19.28 0 12.419C0 5.56 5.57 0 12.445 0S24.89 5.559 24.89 12.42zm-1.606 0c0-6.004-4.883-10.817-10.84-10.817-6.016 0-10.838 4.873-10.838 10.817 0 6.005 4.882 10.817 10.839 10.817 6.017 0 10.839-4.872 10.839-10.817z" fill="#F60" fillRule="nonzero"/>
                </g>
              </svg>
            </div>

          </div>
        </div>
    )
  }
}


export default BuilderCard;



// WEBPACK FOOTER //
// ./src/components/builder/components/builder-card.js